module.exports = __webpack_public_path__ + "img/jx-0001-19-1.asm.f56e76fb.jpg";